import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../web/components-v2/Theme/theme';

const { spacing, common, typography, colors } = THEME;

export const styleSheet = StyleSheet.create({
	subtitle: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		margin: spacing.md,
	},
	actionBar: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: spacing.md,
		borderBottom: common.border,
	},
	filterSection: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: spacing.sm,
	},
	filterLabel: {
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.standard,
		marginLeft: spacing.sm,
		whiteSpace: 'nowrap',
		alignSelf: 'center',
	},
	buttonGroup: {
		alignItems: 'center',
		display: 'flex',
		gap: spacing.sm,
	},
	tableContainer: {
		maxHeight: 400,
		overflowY: 'auto' as const,
		border: common.border,
		borderRadius: common.borderRadius,
	},
	tableOverrides: {
		width: '100%',
		minHeight: 'auto',
	},
	columnOne: {
		width: 300,
		minWidth: 300,
		maxWidth: 300,
	},
	columnTwo: {
		width: 120,
		minWidth: 120,
		maxWidth: 120,
	},
	columnThree: {
		width: 280,
		minWidth: 280,
		maxWidth: 280,
	},
	columnFour: {
		width: 150,
		minWidth: 150,
		maxWidth: 150,
	},
	unsavedFieldMapping: {
		backgroundColor: colors.warning.light,
		borderLeft: `3px solid ${colors.warning.main}`,
	},
	deletedFieldMapping: {
		backgroundColor: colors.danger.light,
		borderLeft: `3px solid ${colors.danger.main}`,
	},
	deletedIndicator: {
		color: colors.danger.main,
		fontSize: typography.fontSizes.xxs,
		fontWeight: typography.fontWeights.bold,
		marginLeft: 0,
		display: 'block',
		whiteSpace: 'nowrap' as const,
	},
	newFieldMapping: {
		backgroundColor: colors.success.light,
		borderLeft: `3px solid ${colors.success.main}`,
	},
	newIndicator: {
		color: colors.success.main,
		fontSize: typography.fontSizes.xxs,
		fontWeight: typography.fontWeights.bold,
		marginLeft: 0,
		display: 'block',
		whiteSpace: 'nowrap' as const,
	},
	modifiedIndicator: {
		color: colors.warning.main,
		fontSize: typography.fontSizes.xxs,
		fontWeight: typography.fontWeights.bold,
		marginLeft: 0,
		display: 'block',
		whiteSpace: 'nowrap' as const,
	},
	fieldNameContainer: {
		display: 'flex',
		alignItems: 'center',
		minHeight: 40,
	},
	fieldNameContent: {
		flex: '1',
		minWidth: '0', // Allows text truncation
	},
	statusIndicatorContainer: {
		width: 120,
		flexShrink: 0,
		textAlign: 'right' as const,
		fontSize: typography.fontSizes.xs,
	},
	fieldDescriptionText: {
		fontSize: 12,
		color: colors.text.light,
	},
	deletedFieldText: {
		textAlign: 'left' as const,
		opacity: 0.5,
		padding: spacing.sm,
		color: colors.text.light,
	},
	modalContainer: {
		padding: spacing.lg,
		minWidth: 400,
	},
	modalFieldGroup: {
		marginBottom: spacing.md,
	},
	modalLabel: {
		display: 'block',
		marginBottom: spacing.sm,
		fontWeight: typography.fontWeights.bold,
	},
	modalButtonGroup: {
		display: 'flex',
		gap: spacing.sm,
		justifyContent: 'flex-end',
		marginTop: spacing.lg,
	},
});
